module.exports = __webpack_public_path__ + "static/media/gas.7c24881d.png";